/**
 * Remove slashes from the start and end of a string
 * @param {string} str
 * @return {string}
 */
function stripSlashes(str) {
	return str.replace(/(^\/+|\/+$)/g, '');
}

export default path => {
	[...document.querySelectorAll('a.is-active, a.is-current')].forEach(link => {
		link.classList.remove('is-current');
	});
	[...document.querySelectorAll('a')].forEach(link => {
		// Main Link
		if (stripSlashes(link.pathname) === stripSlashes(path)) {
			link.classList.add('is-current');
		}

		// Parent
		if (
			stripSlashes(link.pathname).length > 0 &&
			stripSlashes(path).indexOf(stripSlashes(link.pathname).split('/')[0]) > -1
		) {
			// Activate parent link
			const linkParentLi = link.closest('[data-parent]');
			if (!linkParentLi) return;
			const linkParent = linkParentLi.querySelector('.nav__link');
			if (!linkParent) return;
			linkParent.classList.add('is-current');
		}
	});
};
